import React, { Component } from 'react';
import { SaleWidgetWrapper } from './style';
// import ToolTipIcon from '../../../image/tooltip.png';
import Tooltip from '../../../components/uielements/tooltip';

export default class SaleWidget extends Component {
  render() {
    const { fontColor, label, price, details, top , tooltip, tooltipTitle, tooltipPlacement='top'} = this.props;

    const textColor = {
      color: fontColor,
    };

    return (
      <SaleWidgetWrapper className="isoSaleWidget"  top={top}>
        <div className="top"/>
        <div className="wrapper">
      
        {/* <h3 className="isoSaleLabel">
        </h3> */}
        <span className="isoSalePrice" style={textColor}>
          {price}
        </span>
        <p className="isoSaleDetails">
          {details}
          <Tooltip placement={tooltipPlacement} title={tooltipTitle}>{tooltip}</Tooltip>
        </p>
        </div>
      </SaleWidgetWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/sale/sale-widget.js